import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLampDistanceToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8691_2144)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.1802 18.13V3.16003",
				stroke: "currentColor",
				strokeWidth: 1.17,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.890137 18.13H18.1701",
				stroke: "currentColor",
				strokeWidth: 1.17,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.89014 3.16003V18.05",
				stroke: "currentColor",
				strokeWidth: 1.17,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.89012 3.16C2.59152 3.16 3.16012 2.5914 3.16012 1.89C3.16012 1.18859 2.59152 0.619995 1.89012 0.619995C1.18872 0.619995 0.620117 1.18859 0.620117 1.89C0.620117 2.5914 1.18872 3.16 1.89012 3.16Z",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.1802 3.16C17.8816 3.16 18.4502 2.5914 18.4502 1.89C18.4502 1.18859 17.8816 0.619995 17.1802 0.619995C16.4788 0.619995 15.9102 1.18859 15.9102 1.89C15.9102 2.5914 16.4788 3.16 17.1802 3.16Z",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.13267 7.35999L4.04004 9.45261L6.13267 11.5452",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9473 11.5452L15.0399 9.45261L12.9473 7.35999",
				stroke: "currentColor",
				strokeWidth: 1.25,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.04004 9.45264H15.04",
				stroke: "currentColor",
				strokeWidth: 1.25
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8691_2144",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19.07,
			height: 18.72,
			fill: "currentColor"
		})
	}) })]
});
export default SvgLampDistanceToolbar;
